import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';

@Injectable()
export class ConfigService {
  private testMode = false;

  constructor(/*private route: ActivatedRoute*/) {
    const urlParams = new URLSearchParams(window.location.search);
    const queryParamTest = urlParams.get('test');
    console.log('QueryParam queryParamTest: ' + queryParamTest);

    this.testMode = (/true|yes/i).test(queryParamTest);
    console.log('ConfigService testMode: ' + this.testMode)
  }

  public getGATrackingID() {
    const hostname: string = window.location.hostname;

    let gaTrackingID;
    if (this.testMode || hostname.includes('staging') || hostname.includes('qa') || hostname.includes('test') || hostname.includes('localhost') || hostname.includes('dev')) {
      gaTrackingID = environment.DEV_TEST_gaTrackingID;
    } else {
      if (hostname.includes('.org')) {
        gaTrackingID = environment.PROD_ORG_gaTrackingID;
      } else {
        gaTrackingID = environment.PROD_gaTrackingID;
      }
    }

    console.log('ConfigService: gaTrackingID set to: ' + gaTrackingID);
    return gaTrackingID;
  }

  public getPublicKey(): string {
    const hostname: string = window.location.hostname;

    let publicKey;
    if (this.testMode || hostname.includes('staging') || hostname.includes('qa') || hostname.includes('test') || hostname.includes('localhost') || hostname.includes('dev')) {
      publicKey = environment.DEV_TEST_QA_adyenPublicKey;
    } else {
      publicKey = environment.PROD_adyenPublicKey;
    }

    console.log('ConfigService: publicKey set to: ' + publicKey);
    return publicKey;
  }

  public getBaseUrl(): string {
    const baseUrl = this.getApiUrl();

    console.log('ConfigService: API baseUrl set to: ' + baseUrl);
    return baseUrl;
  }

  private getApiUrl(): string {
    const protocol: string = window.location.protocol;
    console.log('protocol: ' + protocol)

    const regex = /w+\./gi;
    return protocol + '//' + this.getApiHostName() + this.getApiPortSuffix() + this.getApiContextRoot();
  }

  private getApiContextRoot(): string {
    const hostname: string = window.location.hostname;

    let contextRoot = '';

    // Exceptions
    if (hostname.includes('localhost') || hostname.includes('dev')) {
      contextRoot = '/frontend-api-web/rest';
    }
    return contextRoot;
  }

  private getApiHostName(): string {
    const hostname: string = window.location.hostname;

    const regex = /w+\./gi;
    return 'api.' + (this.testMode ? 'test.' : '') + hostname.replace(regex, '');
  }

  private getApiPortSuffix(): string {
    let port: string = window.location.port;

    // Exceptions
    if ('4200' === port) {
      port = '80';
    }

    if ('443' === port || '80' === port) {
      port = null;
    }

    // make it a portSuffix (add :)
    return port == null ? '' : ':' + port;
  }
}
